import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import type { OperationalHelpAskRequest } from "../../Objects/OperationalHelp/OperationalHelpAskRequest"
import type { OperationalHelpAskResponse } from "../../Objects/OperationalHelp/OperationalHelpAskResponse"
import { PostRequest } from "../../services/ApiClientService"

export const useOperationalHelp = () => {
  const askOperationalHelp = async (
    request: OperationalHelpAskRequest,
    requestType: ERequestType,
  ): Promise<OperationalHelpAskResponse> => {
    const response = await PostRequest<OperationalHelpAskResponse>(
      API_ROUTES.OPERATIONAL_HELP.ASK,
      request,
      requestType,
    )

    if (!response.success || !response.data) {
      throw new Error(response.message)
    }

    return response.data
  }

  return { askOperationalHelp }
}
